import { LANTERN_ERROR_CODES } from '../../constants/error';

export class RecordingError extends Error {
    constructor(message) {
        super(message);
        // hack to make `myerr instanceof RecordingError` work
        this.constructor = RecordingError;
        this.__proto__ = RecordingError.prototype;
        this.message = message;
        this.name = 'RecordingError';
    }
}

export class NoRecordingError extends RecordingError {
    constructor(message = 'No recording in store') {
        super(message);
        this.constructor = NoRecordingError;
        this.__proto__ = NoRecordingError.prototype;
        this.message = message;
        this.name = 'NoRecordingError';
    }
}

export class RecordingSizeError extends RecordingError {
    constructor(message = 'Audio size threshold not met') {
        super(message);
        this.constructor = RecordingSizeError;
        this.__proto__ = RecordingSizeError.prototype;
        this.message = message;
        this.name = 'RecordingSizeError';
        this.statusCode = LANTERN_ERROR_CODES.AUDIO_SIZE_THRESHOLD_NOT_MET;
    }
}
